import { createContext } from 'preact'
import { useContext } from 'preact/hooks'
import { assert } from '#shared'
import { createShopState } from '../os/apps/shop/shop-state.ts'
import type { ShopState } from '../os/apps/shop/shop-state.ts'
import { createOsState } from '../os/os-state.ts'
import type { OsState } from '../os/os-state.ts'

/**
 * Each device's OS state (the phone remembers its front app between T presses), and the
 * shop apps' state both devices share (the baskets).
 */
export interface OsStates {
  readonly phone: OsState
  readonly computer: OsState
  readonly shop: ShopState
}

export function createOsStates(): OsStates {
  return {
    phone: createOsState('phone'),
    computer: createOsState('desktop'),
    shop: createShopState(),
  }
}

export const OsStatesContext = createContext<OsStates | null>(null)

export function useOsStates(): OsStates {
  const states = useContext(OsStatesContext)
  assert(states, 'useOsStates() needs <Devices> above it')
  return states
}
